module.exports = __webpack_public_path__ + "img/icon3.0991e68d.png";